import React, { useState } from 'react';
import axios from 'axios';
import { Container, Button, Form, Spinner } from 'react-bootstrap';

function Paypal({ amount, currency, orderId }) {
  const [loading, setLoading] = useState(false);

  const handlePayment = async (e) => {
    e.preventDefault();
    if (!amount || parseFloat(amount) <= 0) {
      alert('Please enter a valid amount.');
      return;
    }

    try {
      setLoading(true);
      // NOUVEAU : Envoi du montant, devise et orderId
      const res = await axios.post('/api/paypal', { amount, currency, orderId });
      
      if (res && res.data) {
        // NOUVEAU : Recherche sécurisée du lien de paiement
        const approvalLink = res.data.links.find(link => link.rel === 'approval_url');
        if (approvalLink) {
          window.location.href = approvalLink.href;
        }
      }
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  };

  return (
    <Container className='d-flex flex-column align-items-center justify-content-center p-0'>
      <Form onSubmit={handlePayment} className='w-100'>
        <Button variant='primary' type='submit' className='w-100 mt-2 py-2' disabled={loading}>
          {loading ? <Spinner size="sm" /> : `Payer ${amount} ${currency === 'EUR' ? '€' : '$'} avec PayPal`}
        </Button>
      </Form>
    </Container>
  );
}

export default Paypal;